import { FC, SVGProps } from 'react';

export const SearchIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.75 15.0507C5.75 9.64468 10.1325 5.26221 15.5385 5.26221C20.9446 5.26221 25.3271 9.64468 25.3271 15.0507C25.3271 20.4568 20.9446 24.8393 15.5385 24.8393C10.1325 24.8393 5.75 20.4568 5.75 15.0507ZM15.5385 3.76221C9.30405 3.76221 4.25 8.81626 4.25 15.0507C4.25 21.2852 9.30405 26.3393 15.5385 26.3393C18.2465 26.3393 20.7317 25.3858 22.6768 23.7962L26.4704 27.5799C26.7636 27.8725 27.2385 27.8718 27.531 27.5786C27.8235 27.2853 27.8229 26.8104 27.5296 26.5179L23.7737 22.7717C25.6674 20.7528 26.8271 18.0372 26.8271 15.0507C26.8271 8.81626 21.773 3.76221 15.5385 3.76221Z"
			fill="currentColor"
		/>
	</svg>
);
